// extracted by mini-css-extract-plugin
export default {"cardTotal":"CardTotalPointHistory_cardTotal__IBDxc","text":"CardTotalPointHistory_text__cbWIz"};